import { constants } from '../../constants';
import axios from 'axios';
import { getAPIService } from '../../lib/axios';


const getFormat = (store_id, storeDetails) => {
	let parameter = {
		params: {
			skip_caching: 1,
			store_id: store_id,
			device_id: store_id,
			latitude: storeDetails.latitude,
			longitude: storeDetails.longitude,
			client_os: constants.clientOs,
		},
	};
	return getAPIService('/api/getformat', parameter);
};
export const getCategory = async (store_id, storeDetails) => {
	let url = `api/get_category`;
	let parameters = {
		params: {
			skip_caching: 1,
			store_id: store_id,
			latitude: storeDetails.latitude,
			longitude: storeDetails.longitude,
			client_os: constants.clientOs,
		},
	};
	return await getAPIService(url, parameters);
}
const getStoreDetails = (store_id) => {
	let parameter = {
		params: {
			skip_caching: 1,
			store_id: store_id,
			client_os: constants.clientOs,
		},
	};
	return getAPIService('api/get_store_details_by_id', parameter);
};

const getProductsByBrand = (brand,store_id) => {
	let parameter = {
		params: {
			store_id: store_id,
			brand_id: brand.brand_id,
			client_source_id: brand.client_source_id,
		},
	};

	return axios.get('/api/productByBrand', parameter);
};


const getAllProductsForBrands = (brands,store_id, storeDetails) => {
	let body = {
		brands: brands,
		store_id,
		latitude: storeDetails.latitude,
		longitude: storeDetails.longitude,
	};

	return axios.post('/api/getAllProducts',body);
};

const getProductCustomization = (store_id,product_id) => {
	let parameter = {
		params: {
			store_id: store_id,
			product_id: product_id,
		},
	};

	return axios.get('/api/productCustomization', parameter);
};

const getProductDetails = (product_id,store_id) => {
	let parameter = {
		params: {
			store_id: store_id,
			product_id: product_id,
			is_metadata_required: true,
		},
	};
	return getAPIService('/api/productDetail', parameter);

};

const getComboDetails = (combo_id,store_id) => {
	let parameter = {
		params: {
			store_id: store_id,
			combo_id: combo_id,
			client_os: constants.clientOs,
		},
	};
	return getAPIService('/api/comboCustomization', parameter);

};

export const productsService = {
	getFormat,
	getCategory,
	getStoreDetails,
	getProductsByBrand,
	getAllProductsForBrands,
	getProductCustomization,
	getProductDetails,
	getComboDetails,
};
